import { render, staticRenderFns } from "./UltimosLances.vue?vue&type=template&id=7f369466"
import script from "./UltimosLances.vue?vue&type=script&lang=js"
export * from "./UltimosLances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports